/**
 * Celebratory Butler lines. Three places, each once:
 * - The activity, the moment an exam is handed in.
 * - The Learn path, the first time the course is at least 20% done.
 * - The Learn path, the first time the course is finished.
 */

const STORAGE_KEY = "acuity-learn-path-cheers";

export type PathCheer = "20" | "100";

function readMap(): Record<string, string[]> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as Record<string, string[]>;
  } catch {
    return {};
  }
}

/** The next path line this course has not shown yet, if the percent has reached it. */
export function unseenPathCheer(courseId: string, percent: number): PathCheer | null {
  if (!courseId || !Number.isFinite(percent)) return null;
  const seen = new Set(readMap()[courseId] || []);
  if (percent >= 100) return seen.has("100") ? null : "100";
  if (percent >= 20) return seen.has("20") ? null : "20";
  return null;
}

export function rememberPathCheer(courseId: string, cheer: PathCheer) {
  if (!courseId) return;
  try {
    const map = readMap();
    const seen = new Set(map[courseId] || []);
    seen.add(cheer);
    if (cheer === "100") seen.add("20");
    map[courseId] = [...seen];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Private mode still shows the line for this visit.
  }
}

export function pathCheerLine(cheer: PathCheer): string {
  if (cheer === "100") return "You finished this course.";
  return "You have finished 20% of this course.";
}

export function finishedExamLine(title: string | null | undefined): string {
  const name = (title || "").trim();
  if (!name) return "You finished this exam.";
  return `You finished ${name}.`;
}
